<ng-container *ngIf="state === 'loading'">
  <a *ngFor="let n of [].constructor(expectedCount)" class="member placeholder">
    <div class="avatar"></div>
    <div class="info">
      <div class="title"><span class="placeholder"></span></div>
      <div class="username"><span class="placeholder"></span></div>
      <div class="about"><span class="placeholder"></span></div>

      <!-- TODO: socials? -->

      <div class="member-badges">
        <div class="member-badge">
          <img src="/assets/community/community-member.svg">
          <div class="info">
            <div class="name"><span class="placeholder"></span></div>
            <div class="detail"><span class="placeholder"></span></div>
          </div>
        </div>

        <div class="member-badge">
          <img src="/assets/community/plus-member.svg">
          <div class="info">
            <div class="name"><span class="placeholder"></span></div>
            <div class="detail">
              <span class="placeholder"></span>
            </div>
          </div>
        </div>

        <div class="member-badge">
          <img src="/assets/community/tyt-army.svg">
          <div class="info">
            <div class="name"><span class="placeholder"></span></div>
            <div class="detail"><span class="placeholder"></span></div>
          </div>
        </div>
      </div>
    </div>
  </a>
</ng-container>
<ng-container *ngIf="state === 'ready'">
  <a *ngFor="let member of members" routerLink="/@{{member.user.username}}" class="member">
    <div class="avatar" [responsiveBackgroundImage]="member.user.avatar"></div>
    <div class="info">
      <div class="title">Community Member</div>
      <div class="username">{{ member.user.username }}</div>
      <div class="about">{{ member.user.profile.tagline }}</div>

      <!-- TODO: socials? -->

      <div class="member-badges">
        <div class="member-badge">
          <img src="/assets/community/community-member.svg">
          <div class="info">
            <div class="name">Community</div>
            <div class="detail">{{member.user.profile.signed_up_at | date: 'shortDate'}}</div>
          </div>
        </div>

        <div class="badge" *ngIf="member.user.profile.member_since">
          <img src="/assets/community/plus-member.svg">
          <div class="info">
            <div class="name">Plus</div>
            <div *ngIf="member.user.profile.member_number" class="detail">
              #{{member.user.profile.member_number}}</div>
          </div>
        </div>

        <div class="badge" *ngIf="member.user.profile.is_tyt_army">
          <img src="/assets/community/tyt-army.svg">
          <div class="info">
            <div class="name">Volunteer</div>
            <div class="detail">TYT ARMY</div>
          </div>
        </div>
      </div>
    </div>

  </a>
</ng-container>
